import classNames from "classnames"

import { useTranslation } from "@bounce/i18n"

import type { PoiListItemProps } from "./PoiListItem"
import { PoiListItem } from "./PoiListItem"
import { getAllOfCityPoiListItemId } from "./utils/getAllOfCityPoiListItemId"
import type { CityData } from "@/libs/bounce/cities"

const MAX_POI_LIST_ITEMS = 10

type PoiListProps = {
  city: CityData
  className?: string
}

const useAllOfCityPoiListItem = ({ city }: Pick<PoiListProps, "city">): PoiListItemProps["poi"] => {
  const { t } = useTranslation()

  const id = getAllOfCityPoiListItemId(city)
  const name = t("screen.cityListViewScreen.poisList.allOfCityPoi", "All of {CITY_NAME}", {
    CITY_NAME: city.translatedName,
  })

  return {
    id,
    slug: id,
    translatedName: name,
    directorySlug: city.directorySlug,
  }
}

export const PoiList = ({ city, className }: PoiListProps) => {
  const { t } = useTranslation()
  const allOfCityItem = useAllOfCityPoiListItem({ city })

  const pois = city.pois
    ?.filter(({ directorySlug }) => directorySlug === "luggage-storage")
    .slice(0, MAX_POI_LIST_ITEMS - 1)

  if (!pois?.length) {
    return null
  }

  return (
    <div className={classNames("w-full max-w-screen-lg", className)}>
      <div className="w-full max-w-screen-lg px-6 lg:px-0">
        <h2 className="font-sans text-lg font-semibold">{t("cmp.poiList.title", "Popular destinations")}</h2>
      </div>
      <ul className="flex flex-nowrap gap-2 overflow-x-auto px-6 pt-4 [-ms-overflow-style:none] [scrollbar-width:none] md:flex-wrap lg:px-0">
        {[allOfCityItem, ...pois].map(poi => (
          <PoiListItem key={poi.id} city={city} poi={poi} />
        ))}
      </ul>
    </div>
  )
}
